import React from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import Offcanvas from 'react-bootstrap/Offcanvas';

const Sidebar = ({ show, onHide }) => {
  return (
    <Offcanvas
        show={show}
        onHide={onHide}
        placement="start"
        className='sidebarColor'
        data-testid="sidebar"
        aria-labelledby="sidebar-title">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title id="sidebar-title" className="text-light">
          Navigation
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
      <ul className="nav nav-pills flex-column mb-auto">
        <li className="nav-item">
          <a href="../" className="nav-link text-white">
            <svg className="bi me-2" width="16" height="16" aria-hidden="true"></svg>
            Home
          </a>
        </li>
        <li>
          <a href="../BASE64_EnDecode" className="nav-link text-white">
            <svg className="bi me-2" width="16" height="16" aria-hidden="true"></svg>
            BASE64 En/Decode
          </a>
        </li>
        <li>
          <a href="../URL_EnDecode" className="nav-link text-white">
            <svg className="bi me-2" width="16" height="16" aria-hidden="true"></svg>
            URL En/Decode
          </a>
        </li>
        <li>
          <a href="../JSON_Formatter" className="nav-link text-white">
            <svg className="bi me-2" width="16" height="16" aria-hidden="true"></svg>
            JSON Formatter
          </a>
        </li>
        <li>
          <a href="../XML_Formatter" className="nav-link text-white">
            <svg className="bi me-2" width="16" height="16" aria-hidden="true"></svg>
            XML Formatter
          </a>
        </li>
        <li>
          <a href="../Unix_Timestamp" className="nav-link text-white">
            <svg className="bi me-2" width="16" height="16" aria-hidden="true"></svg>
            Timestamp
          </a>
        </li>
        <li>
          <a href="../Send_Plain_Text_Email" className="nav-link text-white">
            <svg className="bi me-2" width="16" height="16" aria-hidden="true"></svg>
            Send Plain Text Email
          </a>
        </li>
      </ul>
      <hr></hr>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

// PropTypes validation
Sidebar.propTypes = {
  show: PropTypes.bool.isRequired, // Validate 'show' prop as a required boolean
  onHide: PropTypes.func.isRequired, // Validate 'onHide' prop as a required function
};

export default Sidebar;
